import Dropdown from "../../Components/Fields/Dropdown";
import {
  CheckMandatory,
  ErrorAlert,
  GetRecords,
  saveRecord,
  SuccessAlert,
  UpdateRecord,
  URLPRIFIX,
  getList
} from "../../functions/api";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import String from "../../Components/Fields/String";
import { useStore } from "../../Components/StateProvider";
import FormView from "../../Components/Elements/FormView";
import Journal from "../../Components/Fields/Journal";
import { FaMedal } from "react-icons/fa";
import { Label } from "recharts";
import { IoRibbon } from "react-icons/io5";
import Badge from "@mui/material/Badge";
import Select from "react-select";


const UserForm = () => {
  const { option, id } = useParams();
  const tablename = "user";
  const setrecord = "/users/register";
  const getrecord = `/users/users/${id}`;
  const updaterecord = "/users/updateusers/" + id;
  const updatepasswordAPI = "/users/updatepassword/";
  const store = useStore();

  const modules2 = [
    {
      name: "dashboard",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "users",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "contacts",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "categories",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "films",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "forms",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "nonlitigation_category",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },

    {
      name: "nonlitigation_projects",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "nonlitigation_documents",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "nonlitigation_tasks",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "litigation_projects",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "litigation_tasks",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "trademark_projects",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "trademark_tasks",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "companies",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "AccountGroups",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "ChartsOfAccounts",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "customers",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "vendors",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "budget",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "invoices",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "Expenses",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "companydashboard",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "accountsdashboard",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    // {
    //   name: "Organization_dashboard",
    //   permissions: {
    //     on_off: false,
    //     add: false,
    //     view: false,
    //     update: false,
    //     delete: false,
    //     print: false,
    //   },
    // },
    {
      name: "payables",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "receipts",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "journals",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "configurations",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "balancesheets",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "trialbalance",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "profitandloss",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "customerledger",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "tdsReport",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "reconciliation",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },

    {
      name: "budgetactual",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "daybook",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },

    {
      name: "statement_of_accounts",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "billingreport",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
    {
      name: "template_master",
      permissions: {
        on_off: false,
        add: false,
        view: false,
        update: false,
        delete: false,
        print: false,
      },
    },
  ];
  // role_id list
  // 1 - Admin
  // 2 - Editor
  // 3 - Viewers
  const init = {
    firstname: "",
    lastname: "",
    username: "",
    address: "",
    aadhar_no: "",
    emergency_contact_no: "",
    email: "",
    password: "",
    activestatus: true,
    access_control: modules2,
    role_id: "",
    accountant_companylist: "",
    badgecount: "",
    personal_email: "",
    personal_mobile_no: "",
    emergency_contact_name: "",

  };

  useEffect(() => {
    // console.log("Params",param);

    store.setmodule(tablename, init);
    if (id !== undefined) {
      // HandleRole(store.getvalue("role_id"));
      // console.log("******check role id set",store.getvalue("role_id"))

      GetCompanyList();
      store.setheader(option.toUpperCase() + " USER");
      store.setprops("activestatus", { hidden: false });
      store.setprops("passwordpopup", { hidden: true });
      // props for the Mandatory field
      store.setprops("username", { mandatory: false });
      store.setprops("email", { mandatory: false });
      store.setprops("password", { hidden: true, mandatory: false });
      store.setprops("role_id", { mandatory: false });
      store.setprops("accountant_companylist", { mandatory: false })
      if (option === "profile") {
        store.setprops("username", { hidden: false, readonly: false });
        store.setprops("firstname", { hidden: false, readonly: false });
        store.setprops("lastname", { hidden: false, readonly: false });
        store.setprops("personal_email", { hidden: false, readonly: false });
        store.setprops("personal_mobile_no", { hidden: false, readonly: false });
        store.setprops("emergency_contact_name", { hidden: false, readonly: false });
        store.setprops("email", { hidden: false, readonly: true });
        store.setprops("password", { hidden: true, readonly: true });
        store.setprops("activestatus", { hidden: true, readonly: false });
        store.setprops("access_control", { hidden: false, readonly: true });
        store.setprops("role_id", { hidden: false, readonly: true });
        store.setprops("accountant_companylist", { hidden: false, readonly: true });
        store.setprops("status", { hidden: false, readonly: true });
      } else if (option === "view") {
        store.setprops("firstname", { hidden: false, readonly: true });
        store.setprops("lastname", { hidden: false, readonly: true });
        store.setprops("username", { hidden: false, readonly: true });
        store.setprops("email", { hidden: false, readonly: true });
        store.setprops("personal_email", { hidden: false, readonly: true });
        store.setprops("personal_mobile_no", { hidden: false, readonly: true });
        store.setprops("emergency_contact_name", { hidden: false, readonly: true });
        //store.setprops("password", { hidden: true, readonly: true });
        store.setprops("activestatus", { hidden: false, readonly: true });
        store.setprops("access_control", { hidden: false, readonly: true });
        store.setprops("role_id", { hidden: false, readonly: true });
        store.setprops("accountant_companylist", { hidden: false, readonly: true });
        store.setprops("status", { hidden: false, readonly: true });
        store.setprops("address", { hidden: false, readonly: true });
        store.setprops("aadhar_no", { hidden: false, readonly: true });
        store.setprops("badgecount", { hidden: false, readonly: true });
        store.setprops("emergency_contact_no", {
          hidden: false,
          readonly: true,
        });
      } else {
        store.setprops("firstname", { hidden: false, readonly: false });
        store.setprops("lastname", { hidden: false, readonly: false });
        store.setprops("username", { hidden: false, readonly: false });
        store.setprops("email", { hidden: false, readonly: false });
        store.setprops("password", { hidden: true, readonly: false });
        store.setprops("personal_email", { hidden: false, readonly: false });
        store.setprops("personal_mobile_no", { hidden: false, readonly: false });
        store.setprops("emergency_contact_name", { hidden: false, readonly: false });
        store.setprops("activestatus", { hidden: false, readonly: false });
        store.setprops("access_control", { hidden: false, readonly: false });
        store.setprops("role_id", { hidden: false, readonly: false });
        store.setprops("accountant_companylist", { hidden: false, readonly: false });
        store.setprops("status", { hidden: false, readonly: false });
        store.setprops("address", { hidden: false, readonly: false });
        store.setprops("aadhar_no", { hidden: false, readonly: false });
        store.setprops("emergency_contact_no", {
          hidden: false,
          readonly: false,
        });

      }
      GetRecords(getrecord).then((res) => {
        console.log("USer Data - ", res, res.record);
        if (res.success) {
          init.firstname = res.record.firstName;
          init.lastname = res.record.lastName;
          init.username = res.record.userName;
          init.address = res.record.address;
          init.aadhar_no = res.record.aadhar_no;
          init.emergency_contact_no = res.record.emergency_contact_no;
          init.email = res.record.email;
          init.personal_email = res.record.personal_email;
          init.personal_mobile_no = res.record.personal_mobile_no;
          init.emergency_contact_name = res.record.emergency_contact_name;
          init.access_control =
            res.record.access_control &&
            res.record.access_control !== "" &&
            JSON.parse(res.record.access_control);
          init.role_id = res.record.role_id;
          init.activestatus = res.record.activeStatus;
          init.badgecount = res.record.badgecount;
          init.accountant_companylist = res.record.accountant_companylist;

          store.reset(init);
          // HandleRole(init.role_id);

        } else if (res.code === 401) {
          ErrorAlert(" Error Found Please contact the Admin");
        }
      });
    } else {
      store.setheader("CREATE NEW USER");
      // props for the Mandatory field
      store.setprops("password", { hidden: false });
      store.setprops("activestatus", { hidden: true });
      store.setprops("username", { mandatory: true });
      store.setprops("email", { mandatory: true });
      store.setprops("password", { mandatory: true });
      store.setprops("role_id", { mandatory: true });
      store.setprops("firstname", { mandatory: false });
      store.setprops("lastname", { mandatory: false });
      store.setprops("access_control", { mandatory: false });
      store.setprops("address", { hidden: false, readonly: false });
      store.setprops("aadhar_no", { hidden: false, readonly: false });
      store.setprops("personal_email", { hidden: false, readonly: false });
      store.setprops("personal_mobile_no", { hidden: false, readonly: false });
      store.setprops("emergency_contact_name", { hidden: false, readonly: false });
      store.setprops("emergency_contact_no", {
        hidden: false,
        readonly: false,
      });
    }
  }, [option, id]);

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  function update() {
    store.startLoading();
    const data = store.getrecord();
    let savedata = { ...data };
    savedata.modifiedBy = store.getuser().id;
    savedata.id = Number(id);
    if (data.role === "4") {
      savedata.company_id = (store.getvalue("accountant_companylist") || []).map(
        (item) => item.value
      );
    }
    savedata.access_control = JSON.stringify(savedata.access_control);
    const email = savedata.email;
    if (!email) {
      store.stopLoading();
      ErrorAlert("Enter Email Address");
      return;
    }
    if (savedata.email && savedata.email !== "" && !validateEmail(email)) {
      store.stopLoading();
      ErrorAlert("Invalid email address. Please enter a valid email.");
      return;
    }
    if (savedata.role_id === "4" || savedata.role_id == 4) {
      savedata.company_id = (store.getvalue("accountant_companylist") || []).map(
        (item) => item.value
      );
    }

    console.log("Submiting data", data);
    if (typeof savedata.activeStatus === "string") {
      savedata.activeStatus = savedata.activeStatus == "true" ? true : false;
    }

    delete savedata.accountant_companylist
    delete savedata.company_id_list
    UpdateRecord(updaterecord, savedata).then((res) => {
      if (res.success) {
        store.stopLoading();
        SuccessAlert("User Updated Successfully");
        // store.reset(init);
        // store.navback();
      } else {
        store.stopLoading();
        ErrorAlert(
          res?.errormessage?.data || " Error Found Please contact the Admin"
        );
      }
    });
  }
  function updatepassword() {
    const data = store.getrecord();
    let result = {
      id: Number(id),
      password: data.password,
    };
    if (CheckMandatory(tablename, store)) {
      UpdateRecord(updatepasswordAPI, result).then((res) => {
        if (res.success) {
          store.stopLoading();
          SuccessAlert("User Password Updated Successfully");
          store.setprops("password", {
            hidden: false,
            readonly: true,
          });
          //  store.navback();
          store.setprops("passwordPopup", { hidden: true });
        }
      });
    }
  }

  function Submit() {
    store.startLoading();
    const data = store.getrecord();
    let savedata = { ...data };
    const email = savedata.email;
    if (savedata.email && !validateEmail(email)) {
      store.stopLoading();
      ErrorAlert("Invalid email address. Please enter a valid email.");
      return;
    }
    savedata.modifiedBy = store.getuser().id;
    savedata.createdBy = store.getuser().id;
    if (typeof savedata.activeStatus === "string") {
      savedata.activeStatus = savedata.activeStatus == "true" ? true : false;
    }
    console.log("Submiting savedata", savedata);
    if (savedata.role_id === "4" || savedata.role_id == 4) {
      savedata.company_id = (store.getvalue("accountant_companylist") || []).map(
        (item) => item.value
      );
    }


    if (CheckMandatory(tablename, store)) {

      savedata.access_control = JSON.stringify(savedata.access_control);
      delete savedata.accountant_companylist
      delete savedata.company_id_list

      saveRecord(setrecord, savedata).then((res) => {
        console.log("Resonce of saveRecord - ", res);
        if (res.success) {
          store.stopLoading();
          SuccessAlert("User Submitted Successfully");
          store.reset(init);
          store.navback();
        } else {
          store.stopLoading();
          ErrorAlert(
            res?.errormessage?.response?.data?.errorMessage ||
            " Error Found Please contact the Admin"
          );
        }
      });
    }
  }

  const handlePermissionChange = (moduleName, permissionType, value) => {
    const updatedModules = store.getvalue("access_control").map((module) => {
      if (module.name === moduleName) {
        return {
          ...module,
          permissions: {
            ...module.permissions,
            [permissionType]: value,
          },
        };
      }
      return module;
    });
    // Now you can store the updated modules back
    // For example:
    store.setvalue("access_control", updatedModules);
  };

  function HandleRole(role) {
    if (role === "1") {
      // ADMIN
      let mod = modules2.map((module) => ({
        ...module,
        permissions: {
          ...module.permissions,
          on_off: true,
          add: true,
          view: true,
          update: true,
          delete: true,
          print: true,
        },
      }));
      store.setvalue("access_control", mod);
    } else if (role === "2") {
      //Editor
      let mod = modules2.map((module) => ({
        ...module,
        permissions:
          module.name === "Expenses"
            ? {
              ...module.permissions,
              on_off: true,
              add: true,
              delete: true,
              view: true,
              update: true,
            }
            : [
              "AccountGroups",
              "ChartsOfAccounts",
              "customers",
              "vendors",
              "budget",
              "invoices",
              "companydashboard",
              "payables",
              "receipts",
              "journals",
              "configurations",
              "balancesheets",
              "trialbalance",
              "profitandloss",
              "customerledger",
              "tdsReport",
              "reconciliation",
              "budgetactual",
              "statement_of_accounts",
              "daybook",
              "accountsdashboard",
            ].includes(module.name)
              ? {
                ...module.permissions,
                on_off: false,
                add: false,
                delete: false,
                view: false,
                update: false,
              }
              : {
                ...module.permissions,
                on_off: true,
                view: true,
                update: true,
              },
      }));

      store.setvalue("access_control", mod);
    } else if (role === "3") {
      //Viewer
      let mod = modules2.map((module) => {
        console.log("HandleRole module", module);
        if (
          [
            "nonlitigation_documents",
            "nonlitigation_projects",
            "nonlitigation_tasks",
            "dashboard",
            "companies",
            "contacts",
            "categories",
            "films",
            "forms",
          ].includes(module.name)
        ) {
          return {
            ...module,
            permissions: { ...module.permissions, on_off: true, view: true },
          };
        } else if (["users"].includes(module.name)) {
          return {
            ...module,
            permissions: {
              ...module.permissions,
              on_off: false,
              update: true,
              view: true,
            },
          };
        } else if (module.name === "Expenses") {
          return {
            ...module,
            permissions: {
              ...module.permissions,
              on_off: true,
              add: true,
              delete: true,
              view: true,
              update: true,
            },
          };
        } else {
          return {
            ...module,
          };
        }
      });
      store.setvalue("access_control", mod);
    } else if (role === "4") {
      // accountant
      let mod = modules2.map((module) => {
        if (
          [
            "dashboard",
            "companies",
            "AccountGroups",
            "ChartsOfAccounts",
            "customers",
            "vendors",
            "budget",
            "invoices",
            "Expenses",
            "payables",
            "receipts",
            "journals",
            "configurations",
            "balancesheets",
            "trialbalance",
            "profitandloss",
            "customerledger",
            "tdsReport",
            "reconciliation",
            "budgetactual",
            "statement_of_accounts",
            "daybook",
            "accountsdashboard",
          ].includes(module.name)
        ) {
          return {
            ...module,
            permissions: {
              ...module.permissions,
              on_off: true,
              add: true,
              view: true,
              update: true,
              delete: true,
              print: true,
            },
          };
        } else if (["users"].includes(module.name)) {
          return {
            ...module,
            permissions: {
              ...module.permissions,
              on_off: false,
              add: false,
              view: true,
              update: true,
              delete: false,
              print: false,
            },
          };
        }
        return module;
      });

      GetCompanyList();
      store.setprops("accountant_companylist", { hidden: false, readonly: false });
      store.setvalue("access_control", mod);

    } else {
      store.setprops("accountant_companylist", { hidden: true, readonly: false });

    }
  }
  function GetCompanyList() {
    getList({
      listUrl: "/api/v2/accountingcompany/getcompany/",
    }).then((res) => {
      if (res.success) {
        let formattedList = (res?.data?.list || []).map((item) => ({
          value: item.id,
          label: item.company_name,
        }));
        store.setvalue("company_id_list", formattedList);
      }
    });
  }


  return (
    <FormView
      actions={[
        {
          Name: "Back",
          onclick: () => {
            store.removemodule("user");
            store.navback();

            store.reset(init);
          },
          visible: true,
        },
        {
          Name: "Edit",
          onclick: () => {
            store.navTo(`/${URLPRIFIX}/users/edit/${id}`);
          },
          visible: option === "view" && store.getprops("update"),
        },
        {
          Name: "Change Password",
          onclick: () => {
            store.setprops("password", {
              hidden: false,
              readonly: false,
              mandatory: true,
            });
            store.setprops("passwordPopup", { hidden: false });
          },
          visible:
            (option === "edit" || option === "profile") &&
            store.getprops("update"),
        },
        {
          Name: "Submit",
          onclick: Submit,
          type: "primary",
          visible: id === undefined,
        },
        {
          Name: "Update",
          onclick: update,
          type: "primary",
          visible:
            (option === "edit" || option === "profile") &&
            store.getprops("update"),
        },
      ]}
    >
      {store.getprops("passwordPopup") &&
        store.getprops("passwordPopup").hidden === false && (
          <div className="absolute top-0 left-0 flex h-full w-full justify-center items-center bg-black bg-opacity-35 z-30 rounded-2xl">
            <div className="bg-secondary p-5 w-[50%] rounded-2xl">
              <String name="password" label="New Password :" />
              <div className="flex justify-end items-center px-[1%] pt-[1%] gap-4">
                <button
                  className="bg-primary text-secondary py-2 px-5 rounded-xl font-bold"
                  onClick={updatepassword}
                >
                  Ok
                </button>
                <button
                  className="bg-tertiary text-primary py-2 px-5 rounded-xl font-bold"
                  onClick={() => {
                    store.setprops("password", {
                      hidden: true,
                      readonly: false,
                    });
                    store.setprops("passwordPopup", { hidden: true });
                  }}
                >
                  Back
                </button>
              </div>
            </div>
          </div>
        )}
      <div className="grid grid-cols-2 gap-3">
        <String name="firstname" label="First Name :" />
        <String name="lastname" label="Last Name :" />
        <String name="username" label="User Name :" />
        <String name="password" label="Password :" />
        <String name="email" label="E-mail :" />
        <String name="personal_email" label="Personal E-mail :" />
        <String name="personal_mobile_no" label="Personal Mobile No:" />


        <Dropdown
          name="role_id"
          label="Role Name:"
          list={[
            { value: "1", label: "Admin" },
            { value: "2", label: "Editor" },
            { value: "3", label: "Viewer" },
            { value: "4", label: "Accountant" },
          ]}
          onchange={HandleRole}
        />
        {store.getvalue("role_id") == 4 && (
          <div
            className={
              "text-[14px] w-full h-full px-3 flex-row items-center gap-3 " +
              (!store.getprops("accountant_companylist")?.hidden ? " flex " : " hidden ")
            }
          >
            <label className="w-fit min-w-[150px] max-w-full">
              Company
              {store.getprops("accountant_companylist")?.mandatory && (
                <span className="text-[#ff2828] text-[14px] h-fit">*</span>
              )}
            </label>
            <Select
              isMulti
              name="Company"
              placeholder="Select company"
              options={store.getvalue("company_id_list") || []}
              value={store.getvalue("accountant_companylist")}
              onChange={(e) => store.setvalue("accountant_companylist", e)}
              isDisabled={store.getprops("accountant_companylist")?.readonly}
            />
          </div>
        )}



        <String name="aadhar_no" label="PAN Card No:" />

        <String name="emergency_contact_name" label="Emergency Contact Name:" />

        <String name="emergency_contact_no" label="Emergency Contact No:" />
        {/* {store.getvalue("badgecount") > 0 && (
          <label className="flex items-center space-x-2">
            &nbsp;&nbsp;
            <div className="relative inline-block">
              <img
                src="/Assets/images/lawBadges.png"
                alt="Notification"
                id="notification"
                className="md:w-[38px] md:h-[48px]"
              />
              {store.getvalue("badgecount") > 0 && (
                <span className="absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-[#2E8B57] text-[#FFFFFF] text-xs md:text-xs font-bold flex items-center justify-center rounded-full w-4 h-3 md:w-5 md:h-5">
                  {store.getvalue("badgecount")}
                </span>
              )}

            </div>
          </label>
        )} */}
        {/* {store.getvalue("badgecount") > 0 && ( */}
        <label className="flex items-center space-x-2">
          &nbsp;&nbsp;
          {/* <div className="relative inline-block"> */}
          <Badge
            //badgeContent={670}

            badgeContent={store.getvalue("badgecount")}
            max={9999}
            showZero={true}
            sx={{
              "& .MuiBadge-badge": {
                backgroundColor: "green",
                color: "white",
                fontSize: "12px",
                width: "28px",
                height: "22x",
                minWidth: "22px",
              },
            }}
          >
            <IoRibbon className="md:w-[28px] md:h-[42px]" />
          </Badge>
          {/* <img
                src="/Assets/images/lawBadges.png"
                alt="badges"
                id="badges"
                className="md:w-[24px] md:h-[32px]"
              /> */}
          {/* {store.getsystemvalue("badgecount") > 0 && (
                <span className=" top-0 right-0 transform translate-x-1/2 -translate-y-1/2 bg-[#2E8B57] text-[#FFFFFF] text-xs md:text-xs font-bold flex items-center justify-center rounded-full w-4 h-3 md:w-5 md:h-5">
                  {store.getsystemvalue("badgecount")}
                </span>
              )} */}
          {/* </div> */}
        </label>
        {/* )} */}

        <span className="col-span-2">
          <Journal name="address" label="Address" />
        </span>
        <Dropdown
          name="activestatus"
          label="Active Status :"
          list={[
            { value: true, label: "Active" },
            { value: false, label: "InActive" },
          ]}
        />
      </div>
      {option !== "profile" && (
        <div className="module-access-control pt-7 px-3">
          <h2 className="font-bold text-[20px]">User Access Control</h2>
          <table className="w-full table-auto border-collapse border border-gray-300">
            <thead>
              <tr>
                <th
                  style={{ "text-align": "left" }}
                  className="border px-6 py-3"
                >
                  Module
                </th>
                {/* <th className="border px-4 py-2">Dashboard</th>
              <th className="border px-4 py-2">Masters</th> */}
                <th className="border px-6 py-3"> On / Off</th>
                <th className="border px-6 py-3">Create</th>
                <th className="border px-6 py-3">View</th>
                <th className="border px-6 py-3">Edit</th>
                <th className="border px-6 py-3">Delete</th>
                <th className="border px-6 py-3">Print</th>
              </tr>
            </thead>
            <tbody>
              {store.getvalue("access_control") &&
                store.getvalue("access_control").map((module) => (
                  <tr key={module.name}>
                    <td
                      style={{ "text-align": "left" }}
                      className="border px-6 py-3"
                    >
                      {module.name.toUpperCase()}
                    </td>

                    <td className="border px-4 py-2 text-center">
                      <input
                        type="checkbox"
                        className="checkbox-size"
                        name={`${module.name}_on_off`}
                        checked={module.permissions.on_off}
                        disabled={store.getprops("access_control")?.readonly}
                        onChange={(e) =>
                          handlePermissionChange(
                            module.name,
                            "on_off",
                            e.target.checked
                          )
                        }
                      />
                    </td>
                    <td className="border px-4 py-2 text-center">
                      <input
                        type="checkbox"
                        className="checkbox-size"
                        name={`${module.name}_add`}
                        checked={module.permissions.add}
                        disabled={store.getprops("access_control")?.readonly}
                        onChange={(e) =>
                          handlePermissionChange(
                            module.name,
                            "add",
                            e.target.checked
                          )
                        }
                      />
                    </td>
                    <td className="border px-4 py-2 text-center">
                      <input
                        type="checkbox"
                        className="checkbox-size"
                        name={`${module.name}_view`}
                        checked={module.permissions.view}
                        disabled={store.getprops("access_control")?.readonly}
                        onChange={(e) =>
                          handlePermissionChange(
                            module.name,
                            "view",
                            e.target.checked
                          )
                        }
                      />
                    </td>
                    <td className="border px-4 py-2 text-center">
                      <input
                        type="checkbox"
                        className="checkbox-size"
                        name={`${module.name}_update`}
                        checked={module.permissions.update}
                        disabled={store.getprops("access_control")?.readonly}
                        onChange={(e) =>
                          handlePermissionChange(
                            module.name,
                            "update",
                            e.target.checked
                          )
                        }
                      />
                    </td>
                    <td className="border px-4 py-2 text-center">
                      <input
                        type="checkbox"
                        className="checkbox-size"
                        name={`${module.name}_delete`}
                        checked={module.permissions.delete}
                        disabled={store.getprops("access_control")?.readonly}
                        onChange={(e) =>
                          handlePermissionChange(
                            module.name,
                            "delete",
                            e.target.checked
                          )
                        }
                      />
                    </td>
                    <td className="border px-4 py-2 text-center">
                      <input
                        type="checkbox"
                        className="checkbox-size"
                        name={`${module.name}_print`}
                        checked={module.permissions.print}
                        disabled={store.getprops("access_control")?.readonly}
                        onChange={(e) =>
                          handlePermissionChange(
                            module.name,
                            "print",
                            e.target.checked
                          )
                        }
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </FormView>
  );
};

export default UserForm;
